/** 100 % stacking (D529): each category's segments become shares of that category's total. */
import { isFiniteNumber } from './numbers.js';
/**
 * Stack non-negative series to 100 %. A negative value cannot be a share of a whole, so it counts as 0 (the caller should not
 * ask for a 100 % stack of signed data). A category whose total is 0 is all zero — an empty column, never NaN.
 */
export function stackPercent(series, length) {
    const n = length ?? series.reduce((m, s) => Math.max(m, s.values.length), 0);
    const totals = Array.from({ length: n }, (_, i) => series.reduce((sum, s) => {
        const v = s.values[i];
        return sum + (isFiniteNumber(v) && v > 0 ? v : 0);
    }, 0));
    const run = new Array(n).fill(0);
    const layers = series.map((s, index) => ({
        key: s.key,
        index,
        points: Array.from({ length: n }, (_, i) => {
            const raw = s.values[i];
            const gap = !isFiniteNumber(raw);
            const value = gap || raw < 0 ? 0 : raw;
            const total = totals[i] ?? 0;
            const y0 = total === 0 ? 0 : (run[i] ?? 0) / total;
            run[i] = (run[i] ?? 0) + value;
            const y1 = total === 0 ? 0 : (run[i] ?? 0) / total;
            return { y0, y1, value, gap };
        }),
    }));
    return { layers, totals };
}
//# sourceMappingURL=stack-percent.js.map